module.exports = __webpack_public_path__ + "static/Cellhover-a53d85184ff92f6710f11645b54d749d.png";